import {
  actionLoading,
  actionSuccess,
  actionErrored,
  actionReset,
} from 'api/helpers';
import { unAuthRequest, authRequest } from 'api/helpers';
import URL from 'api/endpoints';

// View general settings overview - collection
export const VIEW_COLLECTION_OVERVIEW = 'VIEW_COLLECTION_OVERVIEW';

export const viewCollectionOverviewLoading = actionLoading(
  VIEW_COLLECTION_OVERVIEW
);
export const viewCollectionOverviewSuccess = actionSuccess(
  VIEW_COLLECTION_OVERVIEW
);
export const viewCollectionOverviewErrored = actionErrored(
  VIEW_COLLECTION_OVERVIEW
);

export const viewCollectionOverview = (collectionName) => {
  return (dispatch) =>
    authRequest.get(
      dispatch,
      URL.collection + collectionName,
      viewCollectionOverviewLoading,
      viewCollectionOverviewSuccess,
      viewCollectionOverviewErrored
    );
};

// Set general settings - collection
export const UPDATE_COLLECTION_SETTINGS = 'UPDATE_COLLECTION_SETTINGS';

export const updateCollectionSettingsLoading = actionLoading(
  UPDATE_COLLECTION_SETTINGS
);
export const updateCollectionSettingsSuccess = actionSuccess(
  UPDATE_COLLECTION_SETTINGS
);
export const updateCollectionSettingsErrored = actionErrored(
  UPDATE_COLLECTION_SETTINGS
);

export const updateCollectionSettingsReset = actionReset(
  UPDATE_COLLECTION_SETTINGS
);

export const updateCollectionSettings = (collectionName, data) => {
  return (dispatch) =>
    authRequest.post(
      dispatch,
      data,
      URL.collection + collectionName,
      updateCollectionSettingsLoading,
      updateCollectionSettingsSuccess,
      updateCollectionSettingsErrored
    );
};

export const resetUpdateCollectionSettingsState = () => {
  return function (dispatch) {
    dispatch(updateCollectionSettingsReset());
  };
};
